import styled from 'vue-styled-components'
const FrameProps = {
  headerActive: false,
}
const FloatframeActive = styled('div', FrameProps)`
pointer-events: auto;
position: absolute;
width: max-content;
white-space: nowrap;
padding: 2px 12px 0px;
font-family: 'Roboto';
font-size: 12px;
line-height: 12px;
bottom: ${({headerActive}) => headerActive ? '-16px': '100%'};
height: max-content;
left: 0;
z-index: 3;
color: white;
background-color: #12A9FF;
border: 1px solid #12A9FF;

&.disabled {
  background-color: #A9A9A9;
  border: 1px solid #A9A9A9;
  color: white;
}

&.lbl-hover:hover {
  background-color: #F4FCFF;
  border: 1px solid #12A9FF;
  color: #12A9FF;
  cursor: pointer;
}
`
const WrapperProps = {
  position: {},
  isActiveCell: false,
  widgetHeaderActive: false,
}
const Wrapper = styled('div', WrapperProps)`
pointer-events: none;
position: absolute;
width: ${({ position }) => position.width};
height: ${({ position }) => position.height};
top: ${({ position }) => position.top};
left: ${({ position }) => position.left};
z-index: 6;
&::after {
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  border: ${({ isActiveCell, widgetHeaderActive }) => isActiveCell || widgetHeaderActive ? '1px solid #A9A9A9' : '4px solid #12A9FF'};
  z-index: 4;
}
/* border: 3px solid red; */
&.top {
  .lbl-name, .section-tool {
    bottom: 100%;
  }
}
&.bottom {
  .lbl-name, .section-tool {
    top: 100%;
  }
  .section-center-tool {
    top: 100%;
    #section-center-tool-badge {
      bottom: 0px;
      top: 10px;
      margin-top: 10px !important;
      margin-bottom: 0px !important;
    }
  }
}
`
const SectionTool = styled.div`
  position: absolute;
  width: fit-content;
  padding: 5px;
  border-radius: 0px 0px 0px 5px;
  right: 0;
  z-index: 3;
  opacity: 10;
  font-weight: 500;
  transition: all 0.1s ease;
  line-height: 1;
  font-size: 16px;
  margin-right: 4px;
  & > div {
    cursor: pointer;
    margin: 2px;
    border: 1px solid #DFDFDF;
    border-radius: 50%;
    background-color: white;
    color: var(--paragraph);
    font-size: 16px;
    padding: 8px;
    line-height: 1;
    // width: 28px;
    // height: 28px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.075);
    width: 32px;
    height: 32px;
  }
`
const AddSection = styled.div`
  &.top {
    top: calc( 30px / -2 );
  }
  &.bottom {
    bottom: calc( 30px / -2 );
  }
  opacity: 10;
  position: absolute;
  /* background-color: #12A9FF; */
  /* background-color: #12A9FF; */
  z-index: 5;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  height: 30px;
  cursor: pointer;
  // border-radius: 50%;
`
const SectionName = styled.div`
  position: absolute;
  width: max-content;
  white-space: nowrap;
  padding: 5px;
  border-radius: 0px 5px 0px 0px;
  color: #12A9FF;
  left: 0;
  background-color: #F4FCFF;
  opacity: 0;
  z-index: 4;
  font-weight: 500;
  transition: all 0.1s ease;
  line-height: 1;
  font-size: 12px;
  border: 1px solid #12A9FF;

`
const WrapperToolProps = {
  marginHeight: 0
}
const WidgetTool = styled('div',WrapperToolProps)`
  pointer-events: all;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  justify-content: center;
  right: 0;
  font-weight: 500;
  transition: all 0.1s ease;
  line-height: 1;
  font-size: 20px;
  
  .badge {
    padding: 9px 16px;
    gap: 10px;
    position: absolute;
    box-shadow: 0px 8px 16px 0px #00000026;
    &.top {
      bottom: ${({marginHeight}) => marginHeight < 90 ? marginHeight - (marginHeight*0.3) + 'px' : '0px'};
    }
    &.bottom {
      top: ${({marginHeight}) => marginHeight < 90 ? marginHeight - (marginHeight*0.3) + 'px' : '0px'};
    }
    .btn-tool:hover {
      svg, .fs-db-20 {
        color: #24BEE2
      }
    }
  }
`



export {
  FloatframeActive,
  AddSection,
  SectionTool,
  SectionName,
  Wrapper,
  WidgetTool,
}